import { render, staticRenderFns } from "./status-row.vue?vue&type=template&id=2d743313&"
import script from "./status-row.vue?vue&type=script&lang=ts&"
export * from "./status-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports